/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  ProfileExport
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get Export Status
 */
export const getProfileExport = (

 signal?: AbortSignal
) => {


      return axiosClient<ProfileExport>(
      {url: `/profile/export`, method: 'GET', signal
    },
      );
    }




export const getGetProfileExportQueryKey = () => {
    return [
    'profile','export'
    ] as const;
    }


export const getGetProfileExportQueryOptions = <TData = Awaited<ReturnType<typeof getProfileExport>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProfileExportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileExport>>> = ({ signal }) => getProfileExport(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileExport>>, TError, TData>
}

export type GetProfileExportQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileExport>>>
export type GetProfileExportQueryError = ErrorType<void>


/**
 * @summary Get Export Status
 */

export function useGetProfileExport<TData = Awaited<ReturnType<typeof getProfileExport>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileExport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileExportQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Export
 */
export const createProfileExport = (

 signal?: AbortSignal
) => {


      return axiosClient<ProfileExport>(
      {url: `/profile/export`, method: 'POST', signal
    },
      );
    }




export const getCreateProfileExportMutationKey = () => ['createProfileExport'] as const;

export const getCreateProfileExportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfileExport>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProfileExport>>, TError,void, TContext> => {

const mutationKey = getCreateProfileExportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProfileExport>>, void> = () => {


          return  createProfileExport()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProfileExportMutationResult = NonNullable<Awaited<ReturnType<typeof createProfileExport>>>

    export type CreateProfileExportMutationError = ErrorType<unknown>


    /**
 * @summary Create Export
 */
export const useCreateProfileExport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfileExport>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createProfileExport>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateProfileExportMutationOptions(options), queryClient);
    }
